// extracted by mini-css-extract-plugin
export default {"row":"AuthButtons_row__NU-Ul","marginLeft":"AuthButtons_marginLeft__1fVeT","btnText":"AuthButtons_btnText__j-z2l","wrapperAuthButtons":"AuthButtons_wrapperAuthButtons__dWG3p"};